import React, { useRef, useEffect, useState } from "react";
import Title from "../layouts/Title";
import SkillCategory from "./SkillCategory";

const Skills = () => {
  const [visibleCategories, setVisibleCategories] = useState([]);
  const categoriesRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            setVisibleCategories((prev) => [...prev, index]);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    const currentCategories = categoriesRef.current;
    currentCategories.forEach((category) => {
      if (category) observer.observe(category);
    });

    return () => {
      currentCategories.forEach((category) => {
        if (category) observer.unobserve(category);
      });
    };
  }, []);

  const skillCategories = [
    {
      title: "AI & Machine Learning",
      skills: [
        "OpenAI GPT-3.5/4",
        "Google Gemini",
        "Prompt Engineering",
        "NLP/NLU",
        "RAG Implementation",
        "AI Automation (n8n, Make.com)",
        "Hugging Face",
      ],
    },
    {
      title: "Technical & Development",
      skills: [
        "WordPress",
        "WooCommerce",
        "JavaScript",
        "PHP",
        "React",
        "API Integration",
        "SDLC",
        "Git",
        "Performance Optimization",
      ],
    },
    {
      title: "Product Management",
      skills: [
        "Agile (Scrum/Kanban)",
        "PLM",
        "Data-Driven Roadmapping",
        "Stakeholder Management",
        "Requirements Engineering",
        "JIRA",
        "ClickUp",
      ],
    },
    {
      title: "Data & Analytics",
      skills: [
        "E-commerce Analytics",
        "CRO",
        "A/B Testing",
        "Google Analytics",
        "Data Visualization",
        "SQL",
      ],
    },
  ];

  return (
    <section id="skills" className="w-full py-20 section-divider">
      <div className="max-w-screen-xl mx-auto px-4">
        <Title title="Skills & Technologies" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {skillCategories.map((category, index) => (
            <div
              key={index}
              ref={(el) => (categoriesRef.current[index] = el)}
              data-index={index}
              className="bg-cardBg bg-opacity-30 rounded-[10px] transform transition-all duration-700"
              style={{
                opacity: visibleCategories.includes(index) ? 1 : 0,
                transform: visibleCategories.includes(index)
                  ? "translateY(0)"
                  : "translateY(30px)",
                transitionDelay: `${index * 150}ms`,
              }}
            >
              <SkillCategory title={category.title} skills={category.skills} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
